// whether an element sits inside a control (a button, link, label, panel header, tab, option or menu item). A control
// can't hold another control (screen readers lose it, and axe reports nested-interactive), so shared pieces that are
// otherwise buttons (status chips, avatars) stay plain there. Call it from ngOnInit: the host is in place by then, also
// when a parent stamps the component in with ngTemplateOutlet
export function isInsideControl(element: HTMLElement): boolean {
  return !!element.parentElement?.closest(
    'button, a, label, [role="button"], [role="tab"], [role="option"], [role="menuitem"]'
  );
}
